import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'isRight'].includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    display: ['none', 'flex'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const Content = styled(Flex)`
  position: relative;
`

const gradientRightCss = ({ isRight }) =>
  isRight &&
  css`
    background: linear-gradient(
      to left,
      ${themeGet('colors.white')} 30%,
      85%,
      RGBA(255, 255, 255, 0)
    );
    right: 0;
  `

export const Gradient = styled(Flex).withConfig({
  shouldForwardProp,
})`
  width: 33%;
  height: 100%;
  position: absolute;
  z-index: 2;
  top: 0;

  background: linear-gradient(
    to right,
    ${themeGet('colors.white')} 30%,
    85%,
    RGBA(255, 255, 255, 0)
  );

  ${gradientRightCss};
`
